import courseservice from '../../services/CourseService';

const getInitialState = function () {
  return {
    filter_text: '',
    selectedLanguages: [],
    tagSlug: null,
    presenter: null,
    chosen_network: '0', // 0 for show all
  };
};

const getInitialStateWithCourses = function () {
  return {
    ...getInitialState(),
    courses: [],
    myManagedCourses: [],
    myEnrolledCourses: [],
    discoverCourses: [],
  };
};

export default {
  namespaced: true,

  state: getInitialStateWithCourses(),

  getters: {
    isAnyFilterSelected: function (state) {
      const initialState = getInitialState();
      return (
        state.filter_text !== initialState.filter_text ||
        JSON.stringify(state.selectedLanguages) !== JSON.stringify(initialState.selectedLanguages) ||
        state.tagSlug !== initialState.tagSlug ||
        state.presenter !== initialState.presenter ||
        state.chosen_network !== initialState.chosen_network
      );
    },

    getRequest: function (state) {
      let request = {};
      request.query = state.filter_text;
      request.tag = state.tagSlug ? (Array.isArray(state.tagSlug) ? (state.tagSlug.map(function (t) {
        return t.slug;
      })) : [state.tagSlug.slug]) : null;
      request.presenter = state.presenter ? state.presenter.id : null;

      request.languages = state.selectedLanguages.map(function (l) {
        return l.id;
      });

      if (state.chosen_network != '' && state.chosen_network != '0') {
        request.network = state.chosen_network;
      } else {
        request.network = null; // load all networks
      }

      return request;
    },

    getMyManagedCourses: function (state) {
      return state.myManagedCourses;
    },
    getMyEnrolledCourses: function (state) {
      return state.myEnrolledCourses;
    },
    getOtherCourses: function (state) {
      return state.discoverCourses;
    },
  },

  mutations: {
    RESET_STATE(state) {
      Object.assign(state, getInitialStateWithCourses());
    },
    filter_text(state, payload) {
      state.filter_text = payload;
    },
    tagSlug(state, payload) {
      state.tagSlug = payload;
    },
    presenter(state, payload) {
      state.presenter = payload;
    },
    selectedLanguages(state, payload) {
      state.selectedLanguages = payload;
    },
    chosen_network(state, payload) {
      if (payload != '') {
        state.chosen_network = payload;
      }
    },
    SET_COURSES(state, { myManagedCourses, myEnrolledCourses, discoverCourses }) {
      state.myManagedCourses = myManagedCourses;
      state.myEnrolledCourses = myEnrolledCourses;
      state.discoverCourses = discoverCourses;
    },
  },

  actions: {
    loadCourses: function ({ commit }) {
      return courseservice.getAll().then(data => {
        if (data && typeof data === 'object') {
          const { myManagedCourses, myEnrolledCourses, discoverCourses } = data;
          commit('SET_COURSES', { myManagedCourses, myEnrolledCourses, discoverCourses });
        } else {
          console.error('Expected an object but got:', data);
        }
      }).catch(error => {
        console.error('Failed to load courses:', error);
      });
    },
  },
};